import { getMockDataByKeys } from "./mock";

export const NOTIFY = {
  name: "notify",
  uuid: 0x6f01,
  properties: ["read", "write", "notify"],
};
export function generateMockDURNofifyData(): DomianControl.SBTVNotifyData {
  const data = getMockDataByKeys([
    "UIRx_WhlBrkTqAct_FL_BCh1",
    "UIRx_WhlBrkTqAct_FR_BCh1",
    "UIRx_WhlBrkTqAct_RL_BCh1",
    "UIRx_WhlBrkTqAct_RR_BCh1",
    "UIRx_ACUYawRate",
    "MCUF_MotToq",
    "MCUR_MotToq",
  ]);
  return data;
}
